
import { useState } from 'react';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import ValueStatement from './components/ValueStatement';
import ServicesSection from './components/ServicesSection';
import AudiencesSection from './components/AudiencesSection';
import CaseStudySection from './components/CaseStudySection';
import PricingSection from './components/PricingSection';
import ConciergeSection from './components/ConciergeSection';
import ContactSection from './components/ContactSection';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F4EF' }}>
      <Navigation />
      <main>
        <HeroSection />
        <MissionSection />
        <ValueStatement />
        <ServicesSection />
        <AudiencesSection />
        <CaseStudySection />
        <PricingSection />
        <ConciergeSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
